<template>
<v-container fill-height fluid justify="center" align="center">
  <!-- <preloader v-if="loading" text="Loading Quiz Items"/> -->
  <v-col cols="12" md="6" offset-md="3">
	<!-- <h5 class="text-center">Nothing Here Yet.</h5> -->
	
	<v-card class="mb-5" raised>

			<!-- lazy-src="https://ak.picdn.net/shutterstock/videos/22276078/thumb/10.jpg" -->
		<v-list-item three-line>
			<v-list-item-content>
			<div class="overline mb-n1">QUESTION {{ currentIndex + 1 }} OF {{ examLength }}</div>
			<!-- <v-list-item-title class="headline">
			</v-list-item-title> -->
			<v-container fluid class="quiz-multiple">		
				<v-img
					contain
					v-if="question.image"
					:src="question.image"/>
				<p v-if="question" 
					class="question"
					v-html="question.question">
				</p>
				<p v-if="question && question.subQuestion"
					class="font-weight-bold"
					v-html="question.subQuestion">
				</p>

				<v-radio-group v-if="question" 
					v-model="question.userAnswer">
					<v-radio class="mb-2"
						v-for="(choice, choiceIndex) in question.choices"
						:key="choiceIndex"
						:label="choice"
						:value="choice"
						hide-details>
					</v-radio>
				</v-radio-group>
			</v-container>

			</v-list-item-content>
		</v-list-item>

		<v-card-actions>
		<v-spacer></v-spacer>

			<v-btn color="primary"
				@click="prev()">
				<v-icon left>mdi-arrow-left</v-icon>
				Prev
			</v-btn>

			<v-btn color="primary"
				v-if="currentIndex < examLength - 1"
				@click="next()">
				<v-icon left>mdi-arrow-right</v-icon>
				Next
			</v-btn>

			<v-btn color="red" dark
				v-if="currentIndex == examLength - 1"
				@click="submit()">
				<v-icon left>mdi-check</v-icon>
				Submit
			</v-btn>
		</v-card-actions>
	</v-card>

  </v-col>
</v-container>
</template>

<script>
import Notify from '../../services/notify'

export default {
	props: [ 'question', 'currentIndex', 'examLength' ],
	data() {
		return {
		}
	},
	methods: {
		prev() {
			this.$emit('prev');
		},

		next() {
			this.$emit('next');
		},

		submit() {
			Notify.confirm('Submit Answers?', 'This will end your examination session.')
				.then(() => {
					this.$emit('submit');
				});
		},

		// answerSelected(value) {
		// 	this.$emit('answer-selected', value);
		// }
	}
}
</script>


<style scoped>
	.question {
		font-size: 1.2rem !important;
		text-align: justify;
		text-justify: inter-word !important;
	}
</style>